<template>
  <div :class="['test', { 'test--ready': pageReady }]">
    <headerPage></headerPage>
    <div class="test-page-content">
      <section class="test-hero">
        <div class="test-hero__main">
          <div class="test-hero__eyebrow">EXAM CENTER</div>
          <h1 class="test-hero__title">考试中心</h1>
          <p class="test-hero__desc">
            将考试列表、状态信息与答题入口统一成更清晰的卡片布局，整体主题与首页等页面保持一致，方便快速查看和进入考试。
          </p>
          <div class="test-hero__stats">
            <div class="hero-stat-card">
              <div class="hero-stat-card__label">全部考试</div>
              <div class="hero-stat-card__value">{{ test.length }}</div>
            </div>
            <div class="hero-stat-card">
              <div class="hero-stat-card__label">待参加</div>
              <div class="hero-stat-card__value">{{ pendingCount }}</div>
            </div>
            <div class="hero-stat-card">
              <div class="hero-stat-card__label">已完成</div>
              <div class="hero-stat-card__value">{{ finishedCount }}</div>
            </div>
          </div>
        </div>
        <div class="test-hero__notice glass-panel">
          <div class="panel-title">考前须知</div>
          <div class="panel-subtitle">建议在进入考试前确认以下事项</div>
          <div class="notice-list">
            <div v-for="(item, index) in examNotices" :key="index" class="notice-item">
              <span class="notice-item__index">{{ index + 1 }}</span>
              <span class="notice-item__text">{{ item }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="test-section">
        <div class="section-header">
          <div>
            <div class="section-header__eyebrow">My Exams</div>
            <div class="section-header__title">考试列表</div>
          </div>
          <div class="section-header__meta">共 {{ test.length }} 场考试</div>
        </div>

        <div v-if="test.length" class="test-card-grid">
          <article v-for="(item, index) in test" :key="item.id" class="test-card glass-panel" :style="{ '--card-index': index }">
            <div class="test-card__head">
              <div>
                <div class="test-card__title">{{ item.name || '未命名考试' }}</div>
                <div class="test-card__scene">{{ item.taskName || '暂无所属场景' }}</div>
              </div>
              <span :class="['schedule-badge', `schedule-badge--${getScheduleType(item.schedule)}`]">
                {{ item.schedule || '待开始' }}
              </span>
            </div>

            <div class="test-card__body">
              <div class="meta-item">
                <span class="meta-item__label">讲师</span>
                <span class="meta-item__value">{{ item.createBy || '-' }}</span>
              </div>
              <div class="meta-item">
                <span class="meta-item__label">时长</span>
                <span class="meta-item__value">{{ item.totalTime || 0 }} 分钟</span>
              </div>
              <div class="meta-item">
                <span class="meta-item__label">总分</span>
                <span class="meta-item__value">{{ item.totalScore || 0 }} 分</span>
              </div>
              <div class="meta-item">
                <span class="meta-item__label">成绩</span>
                <span class="meta-item__value">{{ formatScore(item) }}</span>
              </div>
              <div v-if="item.submitted" class="meta-item meta-item--full">
                <span class="meta-item__label">阅卷状态</span>
                <span class="meta-item__value">{{ formatReviewStatus(item) }}</span>
              </div>
              <div class="meta-item meta-item--full">
                <span class="meta-item__label">开始时间</span>
                <span class="meta-item__value">{{ item.startTime || '-' }}</span>
              </div>
              <div class="meta-item meta-item--full">
                <span class="meta-item__label">截止时间</span>
                <span class="meta-item__value">{{ item.endTime || '-' }}</span>
              </div>
            </div>

            <div class="test-card__footer">
              <div class="test-card__progress">
                <span class="test-card__progress-label">当前状态</span>
                <span>{{ item.schedule || '未开始' }}</span>
              </div>
              <el-button
                @click="toTestInfo(item)"
                icon="el-icon-right"
                size="small"
                type="primary"
                round
                :loading="navigatingExamId === item.id"
                :disabled="navigatingExamId !== null && navigatingExamId !== item.id"
                class="test-card__action"
              >
                {{ getActionText(item.schedule) }}
              </el-button>
            </div>
          </article>
        </div>

        <div v-else class="test-empty glass-panel">
          <el-empty description="当前暂无可参加的考试"></el-empty>
        </div>
      </section>
    </div>
    <bottomPage></bottomPage>
  </div>
</template>

<script>
import { getTestListByUser } from '../../api/api'
import headerPage from '../../components/header/header'
import bottomPage from '../../components/bottom/bottom'

export default {
  components: {
    headerPage,
    bottomPage
  },
  data() {
    return {
      test: [],
      pageReady: false,
      navigatingExamId: null,
      examNotices: [
        '提前检查键盘、鼠标、摄像头和网络状态，避免影响作答。',
        '关闭与考试无关的软件与弹窗，保证页面保持聚焦。',
        '建议使用谷歌浏览器并保持窗口最大化。',
        '涉及监考时，请确保面部始终位于摄像区域内。'
      ]
    }
  },
  computed: {
    pendingCount() {
      return this.test.filter(item => this.getScheduleType(item.schedule) === 'pending').length
    },
    finishedCount() {
      return this.test.filter(item => this.getScheduleType(item.schedule) === 'finished').length
    }
  },
  methods: {
    getTestListByUser() {
      getTestListByUser().then(res => {
        if (res.code === 1000) {
          this.test = Array.isArray(res.data) ? res.data : []
        }
      })
    },
    toTestInfo(item) {
      const id = item && item.id
      if (this.navigatingExamId !== null) {
        return
      }
      this.navigatingExamId = id
      const scheduleType = this.getScheduleType(item && item.schedule)
      window.setTimeout(() => {
        this.$router.push({
          path: '/testInfo',
          query: {
            id,
            autoStart: scheduleType === 'finished' ? '0' : '1'
          }
        })
      }, 180)
    },
    getScheduleType(schedule) {
      if (schedule === '已完成') {
        return 'finished'
      }
      if (schedule === '进行中') {
        return 'active'
      }
      return 'pending'
    },
    getActionText(schedule) {
      if (schedule === '已完成') {
        return '查看详情'
      }
      if (schedule === '进行中') {
        return '继续答题'
      }
      return '开始考试'
    },
    formatScore(item) {
      if (!item || item.submitted !== true) {
        return '--'
      }
      const score = item.scoreTotal === null || item.scoreTotal === undefined ? 0 : item.scoreTotal
      if (item.reviewStatus === '待阅卷') {
        return `${score} 分（临时）`
      }
      return score + ' 分'
    },
    formatReviewStatus(item) {
      if (!item || item.submitted !== true) {
        return '未提交'
      }
      if (item.reviewStatus === '待阅卷') {
        return `待管理员阅卷（剩余 ${item.pendingReviewCount || 0} 题）`
      }
      return item.reviewStatus || '无需阅卷'
    }
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    this.$nextTick(() => {
      window.requestAnimationFrame(() => {
        this.pageReady = true
      })
    })
    this.getTestListByUser()
  }
}
</script>

<style scoped>
  @import url("../../assets/css/testP/test.css");
</style>
